import React, { useState, useEffect } from 'react';
import { BookmarkContext } from './contexts';
import { logger } from '../utils/logger';



const BookmarkProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [bookmarks, setBookmarks] = useState<string[]>(() => {
    try {
      const savedBookmarks = localStorage.getItem('legacy-catalog-bookmarks');
      return savedBookmarks ? JSON.parse(savedBookmarks) : [];
    } catch (error) {
      logger.error('Failed to load bookmarks from localStorage', error);
      return [];
    }
  });

  // Save bookmarks to localStorage whenever they change
  useEffect(() => {
    try {
      localStorage.setItem('legacy-catalog-bookmarks', JSON.stringify(bookmarks));
    } catch (error) {
      logger.error('Failed to save bookmarks to localStorage', error);
    }
  }, [bookmarks]);

  const toggleBookmark = (id: string) => {
    setBookmarks(prev =>
      prev.includes(id)
        ? prev.filter(bookmark => bookmark !== id)
        : [...prev, id]
    );
  };

  const isBookmarked = (id: string) => bookmarks.includes(id);

  return (
    <BookmarkContext.Provider value={{ bookmarks, toggleBookmark, isBookmarked }}>
      {children}
    </BookmarkContext.Provider>
  );
};

export { BookmarkProvider };
